let ctx;
const SOUNDS = {
  alert: { type: "sine", vol: 0.3, dur: 0.16, seq: [[880, 0], [660, 0.18]] },
  new: { type: "sine", vol: 0.3, dur: 0.16, seq: [[523, 0], [659, 0.15], [784, 0.3]] },
  scan: { type: "triangle", vol: 0.18, dur: 0.12, seq: [[1046, 0]] },
  "scan-ok": { type: "triangle", vol: 0.18, dur: 0.14, seq: [[784, 0], [1046, 0.1]] },
};

export function beep(kind = "alert") {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const s = SOUNDS[kind] || SOUNDS.alert;
    s.seq.forEach(([f, t]) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = s.type; o.frequency.value = f;
      const t0 = ctx.currentTime + t;
      g.gain.setValueAtTime(0.0001, t0);
      g.gain.exponentialRampToValueAtTime(s.vol, t0 + 0.015);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + s.dur);
      o.connect(g).connect(ctx.destination);
      o.start(t0); o.stop(t0 + s.dur + 0.05);
    });
  } catch { /* sem áudio */ }
}

export const fmtDT = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")} ${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}`;
};
